// @ts-nocheck
/**
 * 6529.io API
 * This is the API interface description. Brief terminology overview and an authentication example can be found at <a href=\"https://6529.io/about/api\">https://6529.io/about/api</a>.
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { HttpFile } from '../http/http';

export class ApiCommunityMetricSample {
    'period_start': number;
    'period_end': number;
    'event_count': number;
    'value_count': number;

    static readonly discriminator: string | undefined = undefined;

    static readonly mapping: {[index: string]: string} | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "period_start",
            "baseName": "period_start",
            "type": "number",
            "format": ""
        },
        {
            "name": "period_end",
            "baseName": "period_end",
            "type": "number",
            "format": ""
        },
        {
            "name": "event_count",
            "baseName": "event_count",
            "type": "number",
            "format": ""
        },
        {
            "name": "value_count",
            "baseName": "value_count",
            "type": "number",
            "format": ""
        }    ];

    static getAttributeTypeMap() {
        return ApiCommunityMetricSample.attributeTypeMap;
    }

    public constructor() {
    }
}
